export default __webpack_public_path__ + "static/media/sfondo.71bc8595.jpg";